import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, of } from 'rxjs';
import { AuthService, UserRoles, UserSchema, UserService } from 'src/app/core';
import { AuthInnerRouterParams } from 'src/app/core/components';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-landing-user-menu',
  templateUrl: './landing-user-menu.component.html',
  styleUrls: ['./landing-user-menu.component.scss'],
})
export class LandingUserMenuComponent implements OnInit, AfterViewInit {
  @Input() user?: UserSchema | undefined;
  @Input() isHandset$!: Observable<boolean>;

  @Input() isLoggedIn: boolean = false;
  public isHandset!: boolean;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  private subsink = new SubSink();
  public userRoles = UserRoles;

  public ngOnInit(): void {
    this.updateUserStatus();

    // this.authService.status$.subscribe({
    //   next: (status) => {
    //     this.authService.getUserProfile().subscribe({
    //       next: (user) => {
    //         this.isLoggedIn = true;
    //         this.user = user as UserSchema;
    //       },
    //       error: (er) => {
    //         this.isLoggedIn = false;
    //       },
    //     });
    //   },
    // });
    this.authService.userProfile.subscribe(profile => {
      this.user = profile;
      if (profile && profile.id) this.isLoggedIn = true;
    });
    this.authService.userStatus.subscribe(status => {
      // console.log(status);
    })
  }

  public ngOnChange(changes: SimpleChanges) {
    this.updateUserStatus();
  }

  ngAfterViewInit(): void {
    this.subsink.sink = (this.isHandset$ || of(false)).subscribe((value) => {
      this.isHandset = value;
      this.cdr.detectChanges();
    });
  }

  public openAuthBox(route?: AuthInnerRouterParams) {
    this.authService.openAuthBox('login');
  }

  public logoutUser() {
    this.subsink.sink = this.userService.logoutUser().subscribe(() => {
      this.snackBar.open('با موفقیت خارج شدید', '', { duration: 1000 });
    });
  }

  public updateUserStatus() {
    this.userService
      .isLoggedIn()
      .then((result) => {
        this.isLoggedIn = result;
      })
      .catch(() => {
        this.isLoggedIn = false;
      });
  }
}
